import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'adc-breadcrumb',
  templateUrl: './adc-breadcrumb.component.html',
  styleUrls: ['./adc-breadcrumb.component.scss'],
  standalone: false
})
export class AdcBreadcrumbComponent {
  @Input('type') type: any;
  @Input('data') data: any;
  @Output() link!: EventEmitter<any>;
  breadcrumbActive: string = '';
  showBreadcrumb2: boolean = false;

  constructor() {
    this.link = new EventEmitter();
  }

  toggleActive() {
    this.showBreadcrumb2 = !this.showBreadcrumb2;
    // this.breadcrumbActive = breadcrumbNo;

    // if(breadcrumbNo == 'breadcrumb23') {
    //   this.showBreadcrumb2 = !this.showBreadcrumb2;
    // } else {
    //   this.showBreadcrumb2 = false;
    // }
  }

  toggleBreadcrumb2() {
    setTimeout(() => {
      this.showBreadcrumb2 = false;
    }, 3000);
    this.showBreadcrumb2 = true;
  }
}
